import * as React from "react";

function SvgAll(props) {
  return <svg id="all_svg__Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" xmlSpace="preserve" {...props}><style>{".all_svg__st0{fill:#555d63}"}</style><path className="all_svg__st0" d="M13 11.5v-7l2.3-1.9c.3-.2.7-.1.7.1v10.5c0 .2-.3.3-.7.2L13 11.5zM3 4.5v7L.7 13.4c-.3.2-.7.1-.7-.1V2.7c0-.2.3-.3.7-.2l2.3 2zM11.5 3h-7L2.6.7c-.2-.3-.1-.7.1-.7h10.5c.2 0 .3.3.2.7L11.5 3zM4.5 13h7l1.9 2.3c.2.2.1.7-.2.7H2.7c-.2 0-.3-.3-.2-.7l2-2.3z" /></svg>;
}

export default SvgAll;